export default __webpack_public_path__ + "static/media/quiz4.020ec6ff.jpg";